"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const QueryNameTextField = (_a) => {
    var { query, onChange } = _a, props = __rest(_a, ["query", "onChange"]);
    const cancelButtonRef = (0, react_1.useRef)();
    const previousValueRef = (0, react_1.useRef)(query.name);
    const [value, setValue] = (0, react_1.useState)(query.name);
    const [focus, setFocus] = (0, react_1.useState)(false);
    // update name if changed from prop
    (0, react_1.useEffect)(() => {
        setValue(query === null || query === void 0 ? void 0 : query.name);
        previousValueRef.current = query === null || query === void 0 ? void 0 : query.name;
    }, [query === null || query === void 0 ? void 0 : query.name]);
    const handleSubmit = () => {
        setFocus(false);
        if (value && value !== (query === null || query === void 0 ? void 0 : query.name)) {
            // updateQuery({ name: value });
            onChange === null || onChange === void 0 ? void 0 : onChange(value);
        }
    };
    const handleCancel = () => {
        setFocus(false);
        setValue(previousValueRef.current);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.TextField, Object.assign({ variant: 'outlined', size: 'small', value: value || '', InputProps: {
                endAdornment: focus && (react_1.default.createElement(core_1.InputAdornment, { position: 'end' },
                    react_1.default.createElement(core_1.ButtonGroup, { color: 'primary', variant: 'text' },
                        react_1.default.createElement(core_1.Button, { size: 'small', tabIndex: -1, onClick: handleSubmit },
                            react_1.default.createElement(core_1.Icon, { fontSize: 'large' }, "done")),
                        react_1.default.createElement(core_1.Button, { size: 'small', tabIndex: -1, innerRef: cancelButtonRef, onClick: event => {
                                event.stopPropagation();
                                handleCancel();
                            } },
                            react_1.default.createElement(core_1.Icon, { fontSize: 'small' }, "clear")))))
            }, onFocus: () => setFocus(true), onBlur: event => {
                if (event.relatedTarget === cancelButtonRef.current) {
                    handleCancel();
                }
                else {
                    handleSubmit();
                }
            }, onChange: event => {
                setValue(event.target.value);
            } }, props))));
};
exports.default = QueryNameTextField;
//# sourceMappingURL=QueryNameTextField.js.map